import React from "react";
import { Button, Label, Input } from "@revvsales/components";

class CreateClause extends React.Component {
  state = {
    confirm: true,
    data: "",
  };

  _setClauseLabel = e => {
    const data = e.target.value;
    this.setState({ data });

    if (data.length === 0) {
      this.setState({ confirm: true });
    } else {
      this.setState({ confirm: false });
    }
  };

  render() {
    const { confirmAction, closePopup } = this.props;
    const { data, confirm } = this.state;

    return (
      <div className="createdocumentpopup">
        <div className="row">
          <div className="col-md-12">
            <div className="createdoc-title">Save as a new clause</div>

            <div className="form-group">
              <Label htmlFor="label-name">Name the new clause</Label>
              <Input
                autoFocus
                type="text"
                placeholder="Enter Clause Name here"
                data-test="create-clause-name-inputfield"
                className="form-control label-name"
                onChange={e => this._setClauseLabel(e)}
                value={data}
              />
            </div>

            <div className="createquotepopup-footer popup-footer clearfix">
              <div className="quote-popup-response">
                <Button
                  className="btn btn-transparent"
                  onClick={closePopup}
                  data-test="createclause-discard-btn">
                  Discard
                </Button>
                <Button
                  className="btn btn-danger"
                  id="save-as-new-clause-btn"
                  disabled={confirm}
                  onClick={() => confirmAction(data)}
                  data-test="createclause-create-btn">
                  Create Clause
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateClause;



// WEBPACK FOOTER //
// ./src/components/Document/CreateClause.js